import { useEffect } from 'react';
import type { NextPage } from 'next';

import { Container } from '@dansk-metal/ui';

import { HeroBlock } from '@web/components/hero-block/hero-block';
import { Richtext } from '@web/components/richtext/richtext';

import TemplateLayout from '@web/layouts/template/template';

import { CWindow } from '@web/services/cookieinformation';
import { UmbracoPage } from '@web/services/umbraco/types/documents/UmbracoDocument';
import { HeroBlockType } from '@web/services/umbraco/types/elements/Hero';

export const cookiePageContentAlias = 'cookiePage' as const;

export type CookiePageData = UmbracoPage<typeof cookiePageContentAlias, {
	umbracoUrlName?: string;
	hero: HeroBlockType;
}>;

const CookiePageTemplate: NextPage<{ pageData: CookiePageData }> = ({ pageData }) => {
	useEffect(() => {
		const script = document.createElement('script');
		script.async = false;
		script.id = 'CookiePolicy';
		script.type = 'text/javascript';
		script.dataset.culture = 'DA';

		const element = document.querySelector('#cookie-policy-container');
		if (element) {
			/**
			 * https://stackoverflow.com/a/16231055
			 * [1] Append Script
			 * [2] Set onload callback
			 * [3] Set source
			 */
			element.appendChild(script);
			script.onload = () => {
				return (window as CWindow)?.CookieInformation?.loadConsent();
			};

			script.src = 'https://policy.app.cookieinformation.com/cid.js';
		}

		return () => {
			script.remove();
		};
	}, []); // Leave empty, so useEffect only runs once

	return (
		<TemplateLayout>
			{pageData.properties.hero && <HeroBlock block={pageData.properties.hero} />}
			<Container>
				<Richtext content={'<div id="cookie-policy-container" />'} />
			</Container>
			<div id="cicc-template" />
		</TemplateLayout>
	);
};

export default CookiePageTemplate;
